import tags from '../tags';

const {
  elements: { cold, fire, physical, lightning },
  skillTypes: {
    cc,
    dot,
    pet,
    channeling,
    mobility,
    healing,
    toughness,
    damageBoost,
    resource,
    weaken,
  },
  skillTrees: { primary, secondary, defensive, hunting, devices, archery },
} = tags;

export default [
  {
    name: 'Hungering Arrow',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical],
      },
      {
        name: 'Puncturing Arrow',
        tags: [primary, physical],
      },
      {
        name: 'Serrated Arrow',
        tags: [primary, fire],
      },
      {
        name: 'Shatter Shot',
        tags: [primary, lightning],
      },
      {
        name: 'Devouring Arrow',
        tags: [primary, cold],
      },
      {
        name: 'Spray of Teeth',
        tags: [primary, physical],
      },
    ],
  },
  {
    name: 'Impale',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical],
      },
      {
        name: 'Impact',
        tags: [secondary, physical, cc],
      },
      {
        name: 'Chemical Burn',
        tags: [secondary, fire, dot],
      },
      {
        name: 'Overpenetration',
        tags: [secondary, cold],
      },
      {
        name: 'Ricochet',
        tags: [secondary, lightning],
      },
      {
        name: 'Grievous Wounds',
        tags: [secondary, physical],
      },
    ],
  },
  {
    name: 'Entangling Shot',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical, cc],
      },
      {
        name: 'Chain Gang',
        tags: [primary, physical, cc],
      },
      {
        name: 'Shock Collar',
        tags: [primary, lightning, cc, dot],
      },
      {
        name: 'Heavy Burden',
        tags: [primary, cold, cc],
      },
      {
        name: 'Justice is Served',
        tags: [primary, fire, cc],
      },
      {
        name: 'Bounty Hunter',
        tags: [primary, physical, cc],
      },
    ],
  },
  {
    name: 'Caltrops',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Hooked Spines',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Torturous Ground',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Jagged Spikes',
        tags: [defensive, cc, physical, dot],
      },
      {
        name: 'Carved Stakes',
        tags: [defensive, cc, physical],
      },
      {
        name: 'Bait the Trap',
        tags: [defensive, cc, damageBoost, physical],
      },
    ],
  },
  {
    name: 'Rapid Fire',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, channeling, physical],
      },
      {
        name: 'Withering Fire',
        tags: [secondary, channeling, fire],
      },
      {
        name: 'Frost Shots',
        tags: [secondary, channeling, cold, cc],
      },
      {
        name: 'Fire Support',
        tags: [secondary, channeling, physical],
      },
      {
        name: 'High Velocity',
        tags: [secondary, channeling, lightning],
      },
      {
        name: 'Bombardment',
        tags: [secondary, channeling, fire],
      },
    ],
  },
  {
    name: 'Smoke Screen',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, toughness, physical],
      },
      {
        name: 'Displacement',
        tags: [defensive, toughness, mobility, physical],
      },
      {
        name: 'Lingering Fog',
        tags: [defensive, toughness, physical],
      },
      {
        name: 'Healing Vapors',
        tags: [defensive, toughness, healing, physical],
      },
      {
        name: 'Special Recipe',
        tags: [defensive, toughness, physical],
      },
      {
        name: 'Vanishing Powder',
        tags: [defensive, toughness, physical],
      },
    ],
  },
  {
    name: 'Vault',
    runes: [
      {
        name: 'No Rune',
        tags: [hunting, mobility, physical],
      },
      {
        name: 'Action Shot',
        tags: [hunting, mobility, physical],
      },
      {
        name: 'Rattling Roll',
        tags: [hunting, mobility, cc, physical],
      },
      {
        name: 'Tumble',
        tags: [hunting, mobility, physical],
      },
      {
        name: 'Acrobatics',
        tags: [hunting, mobility, physical],
      },
      {
        name: 'Trail of Cinders',
        tags: [hunting, mobility, fire, dot],
      },
    ],
  },
  {
    name: 'Bolas',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, fire],
      },
      {
        name: 'Volatile Explosives',
        tags: [primary, fire],
      },
      {
        name: 'Thunder Ball',
        tags: [primary, lightning],
      },
      {
        name: 'Freezing Strike',
        tags: [primary, cold, cc],
      },
      {
        name: 'Bitter Pill',
        tags: [primary, lightning, resource],
      },
      {
        name: 'Imminent Doom',
        tags: [primary, fire],
      },
    ],
  },
  {
    name: 'Chakram',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical],
      },
      {
        name: 'Twin Chakrams',
        tags: [secondary, fire],
      },
      {
        name: 'Serpentine',
        tags: [secondary, cold],
      },
      {
        name: 'Razor Disk',
        tags: [secondary, physical],
      },
      {
        name: 'Boomerang',
        tags: [secondary, lightning],
      },
      {
        name: 'Shuriken Cloud',
        tags: [secondary, physical],
      },
    ],
  },
  {
    name: 'Preparation',
    runes: [
      {
        name: 'No Rune',
        tags: [hunting, resource, physical],
      },
      {
        name: 'Invigoration',
        tags: [hunting, resource, physical],
      },
      {
        name: 'Punishment',
        tags: [hunting, resource, physical],
      },
      {
        name: 'Battle Scars',
        tags: [hunting, resource, healing, physical],
      },
      {
        name: 'Focused Mind',
        tags: [hunting, resource, physical],
      },
      {
        name: 'Backup Plan',
        tags: [hunting, resource, physical],
      },
    ],
  },
  {
    name: 'Fan of Knives',
    runes: [
      {
        name: 'No Rune',
        tags: [devices, physical, cc],
      },
      {
        name: 'Pinpoint Accuracy',
        tags: [devices, lightning, cc],
      },
      {
        name: 'Bladed Armor',
        tags: [devices, cold, cc, toughness],
      },
      {
        name: 'Knives Expert',
        tags: [devices, fire, cc],
      },
      {
        name: 'Fan of Daggers',
        tags: [devices, fire, cc],
      },
      {
        name: "Assassin's Knives",
        tags: [devices, physical, cc],
      },
    ],
  },
  {
    name: 'Evasive Fire',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical, mobility],
      },
      {
        name: 'Hardened',
        tags: [primary, physical, toughness],
      },
      {
        name: 'Parting Gift',
        tags: [primary, physical, mobility],
      },
      {
        name: 'Covering Fire',
        tags: [primary, fire, mobility],
      },
      {
        name: 'Focus',
        tags: [primary, cold],
      },
      {
        name: 'Surge',
        tags: [primary, lightning, mobility],
      },
    ],
  },
  {
    name: 'Grenade',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, fire],
      },
      {
        name: 'Tinkerer',
        tags: [primary, fire],
      },
      {
        name: 'Cluster Grenades',
        tags: [primary, fire],
      },
      {
        name: 'Grenade Cache',
        tags: [primary, fire],
      },
      {
        name: 'Stun Grenade',
        tags: [primary, lightning, cc],
      },
      {
        name: 'Cold Grenade',
        tags: [primary, cold, cc, dot],
      },
    ],
  },
  {
    name: 'Shadow Power',
    runes: [
      {
        name: 'No Rune',
        tags: [defensive, healing, physical],
      },
      {
        name: 'Night Bane',
        tags: [defensive, healing, cc, physical],
      },
      {
        name: 'Blood Moon',
        tags: [defensive, healing, physical],
      },
      {
        name: 'Well of Darkness',
        tags: [defensive, healing, physical],
      },
      {
        name: 'Gloom',
        tags: [defensive, healing, toughness, physical],
      },
      {
        name: 'Shadow Glide',
        tags: [defensive, healing, mobility, physical],
      },
    ],
  },
  {
    name: 'Spike Trap',
    runes: [
      {
        name: 'No Rune',
        tags: [devices, fire],
      },
      {
        name: 'Echoing Blast',
        tags: [devices, cold, cc],
      },
      {
        name: 'Custom Trigger',
        tags: [devices, fire],
      },
      {
        name: 'Impaling Spines',
        tags: [devices, physical, cc],
      },
      {
        name: 'Lightning Rod',
        tags: [devices, lightning],
      },
      {
        name: 'Scatter',
        tags: [devices, fire],
      },
    ],
  },
  {
    name: 'Companion',
    runes: [
      {
        name: 'No Rune',
        tags: [hunting, pet, physical],
      },
      {
        name: 'Spider Companion',
        tags: [hunting, pet, physical, cc],
      },
      {
        name: 'Bat Companion',
        tags: [hunting, pet, physical, resource],
      },
      {
        name: 'Boar Companion',
        tags: [hunting, pet, physical, cc, healing, toughness],
      },
      {
        name: 'Ferret Companion',
        tags: [hunting, pet, physical, mobility],
      },
      {
        name: 'Wolf Companion',
        tags: [hunting, pet, physical, damageBoost],
      },
    ],
  },
  {
    name: 'Strafe',
    runes: [
      {
        name: 'No Rune',
        tags: [channeling, archery, physical],
      },
      {
        name: 'Icy Trail',
        tags: [channeling, archery, cold, cc, dot],
      },
      {
        name: 'Drifting Shadow',
        tags: [channeling, archery, lightning],
      },
      {
        name: 'Stinging Steel',
        tags: [channeling, archery, physical],
      },
      {
        name: 'Rocket Storm',
        tags: [channeling, archery, fire],
      },
      {
        name: 'Demolition',
        tags: [channeling, archery, fire],
      },
    ],
  },
  {
    name: 'Elemental Arrow',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, fire],
      },
      {
        name: 'Ball Lightning',
        tags: [secondary, lightning],
      },
      {
        name: 'Frost Arrow',
        tags: [secondary, cold, cc],
      },
      {
        name: 'Immolation Arrow',
        tags: [secondary, fire, dot],
      },
      {
        name: 'Lightning Bolts',
        tags: [secondary, lightning, cc],
      },
      {
        name: 'Nether Tentacles',
        tags: [secondary, physical, healing],
      },
    ],
  },
  {
    name: 'Marked for Death',
    runes: [
      {
        name: 'No Rune',
        tags: [hunting, weaken, physical],
      },
      {
        name: 'Contagion',
        tags: [hunting, weaken, physical],
      },
      {
        name: 'Valley of Death',
        tags: [hunting, weaken, physical],
      },
      {
        name: 'Grim Reaper',
        tags: [hunting, weaken, physical],
      },
      {
        name: 'Mortal Enemy',
        tags: [hunting, weaken, resource, physical],
      },
      {
        name: 'Death Toll',
        tags: [hunting, weaken, healing, physical],
      },
    ],
  },
  {
    name: 'Multishot',
    runes: [
      {
        name: 'No Rune',
        tags: [archery, physical],
      },
      {
        name: 'Fire at Will',
        tags: [archery, lightning],
      },
      {
        name: 'Wind Chill',
        tags: [archery, cold, cc, weaken],
      },
      {
        name: 'Suppression Fire',
        tags: [archery, physical, cc],
      },
      {
        name: 'Full Broadside',
        tags: [archery, physical],
      },
      {
        name: 'Arsenal',
        tags: [archery, fire],
      },
    ],
  },
  {
    name: 'Sentry',
    runes: [
      {
        name: 'No Rune',
        tags: [devices, pet, physical],
      },
      {
        name: 'Spitfire Turret',
        tags: [devices, pet, fire],
      },
      {
        name: 'Impaling Bolt',
        tags: [devices, pet, lightning],
      },
      {
        name: 'Chain of Torment',
        tags: [devices, pet, physical],
      },
      {
        name: 'Polar Station',
        tags: [devices, pet, cold, cc],
      },
      {
        name: 'Guardian Turret',
        tags: [devices, pet, physical, toughness],
      },
    ],
  },
  {
    name: 'Cluster Arrow',
    runes: [
      {
        name: 'No Rune',
        tags: [archery, fire],
      },
      {
        name: 'Dazzling Arrow',
        tags: [archery, lightning, cc],
      },
      {
        name: 'Shooting Stars',
        tags: [archery, physical],
      },
      {
        name: 'Maelstrom',
        tags: [archery, cold, healing],
      },
      {
        name: 'Cluster Bombs',
        tags: [archery, fire],
      },
      {
        name: 'Loaded for Bear',
        tags: [archery, fire],
      },
    ],
  },
  {
    name: 'Rain of Vengeance',
    runes: [
      {
        name: 'No Rune',
        tags: [archery, dot, physical],
      },
      {
        name: 'Dark Cloud',
        tags: [archery, dot, physical],
      },
      {
        name: 'Shade',
        tags: [archery, dot, lightning],
      },
      {
        name: 'Stampede',
        tags: [archery, dot, fire, cc],
      },
      {
        name: 'Anathema',
        tags: [archery, dot, fire],
      },
      {
        name: 'Flying Strike',
        tags: [archery, dot, cold, cc],
      },
    ],
  },
  {
    name: 'Vengeance',
    runes: [
      {
        name: 'No Rune',
        tags: [devices, damageBoost, physical],
      },
      {
        name: 'Personal Mortar',
        tags: [devices, damageBoost, fire],
      },
      {
        name: 'Dark Heart',
        tags: [devices, damageBoost, lightning, toughness],
      },
      {
        name: 'Side Cannons',
        tags: [devices, damageBoost, physical, healing],
      },
      {
        name: 'Seethe',
        tags: [devices, damageBoost, physical, resource],
      },
      {
        name: 'From the Shadows',
        tags: [devices, damageBoost, cold, cc],
      },
    ],
  },
];
